import { useEffect } from "react";

const BEREIK = ".v3-content table, [role='dialog'] table";

function labels() {
  document.querySelectorAll(BEREIK).forEach((t) => {
    // tabel die op de telefoon bewust verborgen is (Tailwind 'hidden md:table' / wrapper 'hidden md:block') heeft al een eigen mobiele weergave
    if (t.hasAttribute("data-mobile-ready") || t.classList.contains("v3-geen-kaart") || t.closest(".v3-geen-kaart") || t.matches(".hidden, .hidden *")) return;
    const koppen = [...(t.tHead?.rows[0]?.cells || [])].map((c) => c.textContent.replace(/\s+/g, " ").trim());
    if (koppen.length < 2) return;
    t.classList.add("v3-kaarten");
    [...t.tBodies].forEach((tb) => [...tb.rows].forEach((r) => {
      let i = 0;
      [...r.cells].forEach((c) => {
        const span = c.colSpan || 1;
        const l = span >= koppen.length ? "" : koppen[i] || "";
        if (c.getAttribute("data-label") !== l) c.setAttribute("data-label", l);
        i += span;
      });
    }));
  });
}

/** Layout v3 telefoon: elke tabel met kolomkoppen wordt een kaartenlijst (kolomnaam per regel via data-label). */
export function useTabelKaarten(actief) {
  useEffect(() => {
    if (!actief) return undefined;
    let raf = 0;
    const plan = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(labels); };
    labels();
    const mo = new MutationObserver(plan);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { mo.disconnect(); cancelAnimationFrame(raf); };
  }, [actief]);
}
